module.exports = __webpack_public_path__ + "static/media/fa-brands-400.e288638e.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/fontawesome/fa-brands-400.woff
// module id = 766
// module chunks = 0